import React from 'react';
import { Grid } from '@mui/material';
import { Project } from '../types/dashboard.types';
import { ProjectCard } from './ProjectCard';

interface ProjectGridProps {
  projects: Project[];
  onOpen: (projectId: string, projectType: "draft" | "publish") => void;
  onRename: (projectId: string, projectName: string) => void;
  onDuplicate: (projectId: string) => void;
  onDelete: (projectId: string, projectName: string) => void;
}

export const ProjectGrid: React.FC<ProjectGridProps> = ({
  projects,
  onOpen,
  onRename,
  onDuplicate,
  onDelete,
}) => {
  return (
    <Grid container spacing={2}>
      {projects.map((project) => (
        <Grid item xs={12} sm={6} md={3} key={project.id}>
          <ProjectCard
            project={project}
            onOpen={onOpen}
            onRename={onRename}
            onDuplicate={onDuplicate}
            onDelete={onDelete}
          />
        </Grid>
      ))}
    </Grid>
  );
};
